import spbAdmin from "./api/SpbAdminApi";
class PoInterface {
    getTable(payload) {
        return spbAdmin.post('spb/pointerface/gettable', payload);
    }

}
export default new PoInterface();